import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import './mobile.css';
import { brandTheme, touchTheme } from './antdTheme';
import { useIsTouch } from './utils/useIsTouch';

import { AuthProvider } from './context/AuthContext';
import { OrgProvider } from './context/OrgContext';
import ErrorBoundary from './components/ErrorBoundary';
import PrivateRoute from './components/PrivateRoute';
import AppShell from './components/AppShell';

import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import ProjectHub from './pages/ProjectHub';
import ReportPage from './pages/ReportPage';
import OrgSetupPage from './pages/OrgSetupPage';
import TeamPage from './pages/TeamPage';
import UserGuide from './pages/UserGuide';

const App: React.FC = () => {
  const touch = useIsTouch();
  return (
  <ErrorBoundary>
  <ConfigProvider theme={touch ? touchTheme : brandTheme}>
  <BrowserRouter>
    <AuthProvider>
      <OrgProvider>
        <ErrorBoundary>
          <Routes>
            {/* Bare pages (no shell) */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/setup" element={<PrivateRoute><OrgSetupPage /></PrivateRoute>} />
            <Route path="/projects/:id/report" element={<PrivateRoute><ReportPage /></PrivateRoute>} />

            {/* Shell layout (sidebar + topbar) */}
            <Route element={<PrivateRoute><AppShell /></PrivateRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/projects/:id" element={<ProjectHub />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/help" element={<UserGuide />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ErrorBoundary>
      </OrgProvider>
    </AuthProvider>
  </BrowserRouter>
  </ConfigProvider>
  </ErrorBoundary>
  );
};

export default App;
